<script setup lang="ts">
import type {
  ItineraryAccommodationUpsellLoaderSegment,
  ItineraryAccommodationUpsellSegment,
} from '../../../../models';
import ItineraryTimeline from '../../ItineraryTimeline.vue';
import AddHotelBanner from '../../AddHotelBanner.vue';

interface AccommodationUpsellSegmentProps {
  segment:
    | ItineraryAccommodationUpsellSegment
    | ItineraryAccommodationUpsellLoaderSegment;
}

const props = defineProps<AccommodationUpsellSegmentProps>();
</script>

<template>
  <ItineraryTimeline :segment-type="props.segment.segmentType">
    <template #banner>
      <AddHotelBanner :ingredient-id="props.segment.context.ingredientId" />
    </template>
  </ItineraryTimeline>
</template>
